export const PROOF_OF_IDENTITY = 'PROOFOFIDENTITY'

export const SERVICENOW_ALLOWED_EMAILS = ['muhammad.asif@pinelabs.com','ashok.t4@pinelabs.com']

export const HARD_POS_AGGREGATOR = 'HARDPOS_AGGREGATOR'

export const INDIA = 'India'

export const PROOF_OF_ADDRESS = 'PROOFOFADDRESS'
